import { Avatar, Button, ButtonGroup, Container, Flex, Heading, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import IconArrowBack from 'assets/icons/icon-arrow-back.svg?react';
import IconArrowNext from 'assets/icons/icon-arrow-next.svg?react';
import IconTable from 'assets/icons/icon-table.svg?react';
import iconUserAvatar from 'assets/icons/icon-user-avatar.svg';
import ActiveTag from 'components/ui/ActiveTag';
import ButtonCreateNew from 'components/ui/ButtonCreateNew';
import ButtonEdit from 'components/ui/ButtonEdit';
import ButtonRemove from 'components/ui/ButtonRemove';
import DateTime from 'components/ui/DateTime';
import EmptyList from 'components/ui/EmptyList';
import FixedBar from 'components/ui/FixedBar';
import { useCompaniesContext } from '../contexts/CompaniesContext';
import { useCompany } from '../hooks/useCompany';
import { useRemoveCompanyRecipient } from '../hooks/useRemoveCompanyRecipient';
import CreateMember from './CreateMember';
import ImportMembers from './ImportMembers';

export default function CompanyRecipientsList({ onBack, isBottomBarVisible = false }: any) {
  const { companyId, modals } = useCompaniesContext();
  const { data: company }  = useCompany(companyId as string);
  
  const { onRemoveCompanyRecipient } = useRemoveCompanyRecipient({ companyId: companyId as string });

  return (
    <>
      <Container 
        variant="internal"
        flexDirection="column" 
        pb="80px"
      >
        <ImportMembers />
        <CreateMember />
        
        <Flex justifyContent="space-between">
          <Heading as="h1" size="h1">
            Membros
            <span>São os usuários ligados a uma empresa que receberão os disparos</span>
          </Heading>

          <ButtonGroup>
            <Button 
              rightIcon={<IconTable />}
              onClick={modals.importMembers.onOpen}
            >
              Adicionar via planilha
            </Button>

            <ButtonCreateNew 
              title="Adicionar novo"
              onClick={modals.createMember.onOpen}
            />
          </ButtonGroup>
        </Flex>

        <TableContainer mt="53px">
          <Table>
            <Thead>
              <Tr>
                <Th>Nome</Th>
                <Th>Status</Th>
                <Th>E-mail</Th>
                <Th>Listas associadas</Th>
                <Th>Cadastrado em</Th>
                <Th w="160px"></Th>
              </Tr>
            </Thead>
            <Tbody>
            { company?.recipients && company.recipients.map(recipient => (
              <Tr key={`row-${recipient.id}`}>
                <Td>
                  <Avatar 
                    size="sm"
                    bgColor="bg.avatar"
                    name={recipient.name}
                    
                  />
                  {recipient.name}
                </Td>
                <Td>
                  <ActiveTag isActive={recipient.active} />
                </Td>
                <Td>
                  {recipient.email}
                </Td>
                <Td>{`${recipient._count.lists} ${recipient._count.lists === 1 ? 'lista' : 'listas'}`}</Td>
                <Td>
                  <DateTime date={recipient.createdAt} />
                </Td>
                <Td>
                  <ButtonGroup ml="auto">
                    <ButtonEdit 
                      to={`/clientes/${company.id}/membros/${recipient.id}/editar`}
                    />
                    <ButtonRemove
                      onClick={() => onRemoveCompanyRecipient({ id: recipient.id })}
                    />
                  </ButtonGroup>


                </Td>
              </Tr>
            ))}
            </Tbody>
          
          </Table>
          { company?.recipients?.length === 0 && (
            <EmptyList 
              icon={iconUserAvatar}
              title="Você ainda não tem membros cadastrados para essa empresa"
              description="Use o botão acima para cadastrar"
              isTable 
            />
          )}
          
        </TableContainer>
      </Container>

{ isBottomBarVisible && (
  <FixedBar>
    <Button
      leftIcon={<IconArrowBack />}
      onClick={() => {
        if (onBack)
          onBack();
      }}
    >
      Voltar
    </Button>

    <Button
      variant="primary"
      rightIcon={<IconArrowNext />}
    >
      Finalizar
    </Button>
  </FixedBar>
)}
      
    </>
  )
}
